import { HttpClient, HttpErrorResponse, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
import { CommonFunctions } from '../common-functions';
import { ApiHeaderService } from 'src/app/core/services/api-header.service';
import { Router } from '@angular/router';
import * as uuid from 'uuid';
import { StorageService } from './storage.service';
@Injectable({
  providedIn: 'root'
})
export class AuthenticationService {
  public server = environment.APIEndpoint;
  public isLoggedIn: boolean = false;
  public urls: any = {
    guestUserToken: this.server + 'api/unsec/user/guest/v2/token',
    createUser: this.server + 'api/unsec/user/v3/create',
    verifySignupOtp: this.server + 'api/user/otp/v3/verify',
    createUserDetails: this.server + 'api/user/v3/update',
    userLogin: this.server + 'api/unsec/kiosk/v1/login',
    initiateResetPassword: this.server + 'api/unsec/user/password/reset/v3/initiate',
    sendOtp: this.server + 'api/unsec/otp/v3/send',
    verifyOtp: this.server + 'api/unsec/user/otp/v3/verify',
    changePassword: this.server + 'api/unsec/user/password/v3/reset',
    refreshToken: this.server + 'user/getRefreshToken/v1',
    userLogout: this.server + 'app/logout/v1',
    tnc: this.server + 'api/cms/termsandconditions/v1/view',
    unsecTnc: this.server + 'portal/termsAndConditions',
    resendOtp: this.server + 'api/sec/v3/send/otp',
    getHelpResendPassword: this.server + 'api/unsec/otp/v3/send',
    deviceToken: this.server + 'api/device/token/v1/create'
  };
  public deviceMetaInfo = {
    "appVersion": "",
    "deviceCountry": "India",
    "deviceCity": "",
    "deviceId": localStorage.getItem("deviceId"),
    "deviceModel": "",
    "platform": "WEB",
    "deviceOSVersion": ""
  };
  public unsecureHeaderData = {
    'Accept-Language': 'EN',
    'Device-Meta-Info': JSON.stringify(this.deviceMetaInfo),
  }
  public headerData = {
    'Accept-Language': 'EN',
    'Authorization': 'Bearer' + ' ' + this.storageService.getAccessToken(),
    'Device-Meta-Info': JSON.stringify(this.deviceMetaInfo)
  };
  constructor(private http: HttpClient, private commonFunction: CommonFunctions,
    private apiHeader: ApiHeaderService,
    private storageService: StorageService,
    private router: Router) {
    this.isLoggedIn = this.commonFunction.verifyLoggedInUser();
  }
  getGuestUserToken(): any {
    let unsecureHeaderData = this.apiHeader.getUnSecureHeader();
    let requestPayload = {
      deviceToken: localStorage.getItem('firebaseDeviceId')
    }
    return this.http.post(this.urls.guestUserToken, requestPayload, { headers: unsecureHeaderData });
  }
  createUser(requestPayload) {
    let unsecureHeaderData = this.apiHeader.getUnSecureHeader();
    return this.http.post(this.urls.createUser, requestPayload, { headers: unsecureHeaderData });
  }
  verifySignupOtp(headers, requestPayload) {
    const mergedHeaders = { ...this.headerData, ...headers };
    return this.http.post(this.urls.verifySignupOtp, requestPayload, { headers: mergedHeaders });
  }
  createUserProfileData(headers, requestPayload) {
    const mergedHeaders = { ...this.headerData, ...headers };
    return this.http.post(this.urls.createUserDetails, requestPayload, { headers: mergedHeaders });
  }
  userLogin(requestPayload): any {
    if (localStorage.getItem("deviceId") == null) {
      localStorage.setItem('deviceId', uuid.v4());
    }
    this.deviceMetaInfo = {
      "appVersion": "",
      "deviceCountry": "India",
      "deviceCity": "",
      "deviceId": localStorage.getItem("deviceId"),
      "deviceModel": "",
      "platform": "WEB",
      "deviceOSVersion": ""
    };
    let unsecureHeaders = {
      'Accept-Language': 'EN',
      'Device-Meta-Info': JSON.stringify(this.deviceMetaInfo),
      'GuestToken': localStorage.getItem('guestUserToken'),
    }
    return this.http.post(this.urls.userLogin, requestPayload, { headers: unsecureHeaders });
  }
  initateResetPassword(requestPayload) {
    let unsecureHeaderData = this.apiHeader.getUnSecureHeader();
    return this.http.post(this.urls.initiateResetPassword, requestPayload, { headers: unsecureHeaderData });
  }
  sendOtp(requestPayload) {
    let unsecureHeaderData = this.apiHeader.getUnSecureHeader();
    return this.http.post(this.urls.sendOtp, requestPayload, { headers: unsecureHeaderData });
  }
  verifyOtp(requestPayload) {
    let unsecureHeaderData = this.apiHeader.getUnSecureHeader();
    return this.http.post(this.urls.verifyOtp, requestPayload, { headers: unsecureHeaderData });
  }
  changePassword(requestPayload) {
    let unsecureHeaderData = this.apiHeader.getUnSecureHeader();
    return this.http.post(this.urls.changePassword, requestPayload, { headers: unsecureHeaderData });
  }
  getRefreshToken(reqBody, getHeaders): Observable<any> {
    const mergedHeaders = { ...this.unsecureHeaderData, ...getHeaders };
    return this.http.post(this.urls.refreshToken, reqBody, { headers: mergedHeaders });
  }
  logout() {
    let headerData = this.apiHeader.getSecureHeader()
    return this.http.get(this.urls.userLogout, { headers: headerData });
  }
  getTncData() {
    if (this.router.url == '/registration/personaldetails') {
      this.isLoggedIn = true;
    }
    if (this.isLoggedIn) {
      return this.http.get(this.urls.tnc, { headers: this.headerData });
    } else {
      let unsecureHeaderData = this.apiHeader.getUnSecureHeader();
      return this.http.get(this.urls.unsecTnc, { headers: unsecureHeaderData });
    }
  }
  resendOtp(reqBody, getHeaders) {
    const mergedHeaders = { ...this.unsecureHeaderData, ...getHeaders };
    return this.http.post(this.urls.resendOtp, reqBody, { headers: mergedHeaders });
  }
  getHelpResendOtp(reqBody) {
    let unsecureHeaderData = this.apiHeader.getUnSecureHeader();
    return this.http.post(this.urls.getHelpResendPassword, reqBody, { headers: unsecureHeaderData });
  }
}
